import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-invite-confirmation-modal',
    templateUrl: './invite-confirmation-modal.component.html',
    styleUrls: ['./invite-confirmation-modal.component.scss'],
    standalone: false
})
export class InviteConfirmationModalComponent implements OnInit {

  constructor(
    private activeModal: NgbActiveModal,
    private router: Router
  ) { }

  ishaveCharQuota: boolean = false
  isRetiredContent: boolean = false
  map_id: any
  invitattionDetailInstance: any
  pre_accepted_character_id: any
  ngOnInit(): void {
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  navigateCharacterCreation() {
    this.closeModal();

    localStorage.setItem('map_id', this.map_id)

    this.router.navigate(['/player-detail', 'create'], { queryParams: { mode: 'create', map_code: this.map_id, playerLevel: this.invitattionDetailInstance.level, fallbackToInvite: true, autoInviteId: this.invitattionDetailInstance.id } });
  }
  navigateToSubscribe() {
    this.closeModal();
    this.router.navigate(['/subscription'], { queryParams: { isUser: true } });
  }
}
